import { parseDateValue } from '@ben/common/date';
import DateInput from '@ben/orion/date-input';
import { type IModularBenefitDetail } from '@ben/shared/types/columbia';
import { StartsOnEnum } from '@ben/shared/types/modular-benefit';
import { format } from 'date-fns';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { fieldCannotBeBlankErrorMessage } from '../../shared/constants';
import useSetDirtyValue from '../hooks/use-set-dirty-value';

interface FixedEnrollmentConfigProps {
  type: 'start' | 'end';
}

export const FixedEnrollmentConfig = ({ type }: FixedEnrollmentConfigProps) => {
  const { control } = useFormContext<IModularBenefitDetail>();
  const setDirtyValue = useSetDirtyValue<IModularBenefitDetail>();

  const isEndDate = type === 'end';

  const title = isEndDate
    ? 'Fixed enrolment end date'
    : 'Fixed enrolment start date';

  const key = isEndDate
    ? 'enrollmentConfig.fixedEnrollmentEndDate'
    : 'enrollmentConfig.fixedEnrollmentStartDate';

  useEffect(() => {
    if (isEndDate) return;
    setDirtyValue('enrollmentConfig.startsOn', StartsOnEnum.SPECIFIC_DATE);
  }, [isEndDate, setDirtyValue]);

  return (
    <Controller
      name={`${key}`}
      control={control}
      render={({ field, fieldState }) => {
        const { ref, ...rest } = field;
        return (
          <DateInput
            {...rest}
            label={title}
            value={field.value ? parseDateValue(field.value) : null}
            onChange={(date) =>
              field.onChange(date ? format(date, 'yyyy-MM-dd') : '')
            }
            errorMessage={fieldState.error?.message}
          />
        );
      }}
      rules={{
        required: fieldCannotBeBlankErrorMessage,
      }}
    />
  );
};
